import React from 'react';
import {TransitionProps} from '@mui/material/transitions';
import {Slide} from '@mui/material';

const SlideTransitionComponent = React.forwardRef(function Transition(props: ISlideTransitionComponentProps, ref: React.Ref<unknown>) {
  return <Slide direction="up" ref={ref} {...props} />
});

export default SlideTransitionComponent;

interface ISlideTransitionComponentProps extends TransitionProps {
  children: React.ReactElement<any, any>
}